import React, {useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {toast} from "react-toastify";
import logo from "../../images/logo.svg";
import useFormValidator from "../../hooks/useFormValidator";
import Button from "../../components/Button/Button";
import "./SignUp.css"

function SignUp({handleRegister, registerMessage, registerError}) {
  const validation = useFormValidator();
  const isFormValid = validation.isValid;
  const [disabled, setIsDisabled] = useState(false);

  function handleSubmit(e) {
    e.preventDefault();
    if (validation.values.password !== validation.values.confirmPassword) {
      toast.error("Пароли не совпадают");
      return;
    }
    handleRegister(validation.values);
    setIsDisabled(true);
  }

  useEffect(() => {
    if (registerMessage) {
      toast.success(registerMessage);
    }
  }, [registerMessage]);

  useEffect(() => {
    if (registerError) {
      toast.error(registerError);
    }
  }, [registerError]);

  return (
    <section className="register-page">
      <div className="register">
        <Link to="/">
          <img src={logo} alt="Логотип" className="logo logo__register" />
        </Link>

        <h1 className="register__title">Добро пожаловать!</h1>

        <form className="register__form" id="register__form" name="register__form" onSubmit={handleSubmit} noValidate>
          <p className="register__input-name">Имя</p>
          <input
            className="register__input"
            id="name"
            name="name"
            type="text"
            value={validation.values.name ?? ""}
            onChange={validation.handleChange}
            minLength="2"
            disabled={disabled}
            required
          />

          <p className="register__input-name">E-mail</p>
          <input
            className="register__input"
            id="email"
            name="email"
            type="email"
            value={validation.values.email ?? ""}
            onChange={validation.handleChange}
            disabled={disabled}
            required
          />

          <p className="register__input-name">Пароль</p>
          <input
            className={`register__input ${!isFormValid ? "register__input_novalide" : ""}`}
            id="password"
            name="password"
            type="password"
            value={validation.values.password ?? ""}
            onChange={validation.handleChange}
            minLength="8"
            disabled={disabled}
            required
          />

          <p className="register__input-name">Повторите пароль</p>
          <input
            className={`register__input ${validation.values.confirmPassword && validation.values.password !== validation.values.confirmPassword ? "register__input_novalide" : ""}`}
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            value={validation.values.confirmPassword ?? ""}
            onChange={validation.handleChange}
            minLength="8"
            disabled={disabled}
            required
          />

          <span className="register__error" id="register__error">
            {[validation.errors.name, validation.errors.email, validation.errors.password, registerMessage, registerError].find(Boolean)}
          </span>

          <Button
            buttonId="register__button"
            buttonName="Зарегистрироваться"
            additionalClass={isFormValid ? "button_active" : ""}
            type="submit"
            disabled={disabled && !isFormValid}
          />
        </form>
        <div className="register__footer">
          <p className="register__footer-question">Уже зарегистрированы?</p>
          <Link className="register__footer-link" to="/signin">
            Войти
          </Link>
        </div>
      </div>
    </section>
  );
}

export default SignUp;
